/**
 * Constants for Home feature (POU, status filters, display counts).
 */

export const POU_DICT_KEY = 'POU_CONTENT';
export const POU_TITLE_DICT_KEY = 'POU_TITLE';
export const DEFAULT_POU_TITLE = 'ШТА ЈЕ ПОУ?';
export const WELCOME_DICT_KEY = 'WELCOME_CONTENT';

// Rich-text блок који описује шта корисник види у АП секцијама на почетној страници
// (АП у спровођењу, АП у припреми, архива) и које опције има.
export const AP_INFO_DICT_KEY = 'HOME_AP_INFO_CONTENT';

// Rich-text empty-state порука која се приказује када не постоји ни АП у спровођењу
// ни АП у припреми.
export const AP_EMPTY_STATE_DICT_KEY = 'HOME_AP_EMPTY_STATE_CONTENT';

export const DEFAULT_WELCOME_CONTENT = `<h1>Добродошли</h1><p>Партнерство за отворену управу - ПОУ је међународна иницијатива чија је сврха унапређење основних вредности и принципа отворене управе.</p>`;

/** Кључеви и подразумеване вредности за едитабилне лабеле на почетној страници */
export const HOME_LABEL_KEYS = {
  GOALS_DESCRIPTION: 'LABEL_GOALS_DESCRIPTION',
  OBLIGATIONS_IMPLEMENTATION: 'LABEL_OBLIGATIONS_IMPLEMENTATION',
  DOCUMENTS_MATERIALS: 'LABEL_DOCUMENTS_MATERIALS',
  DRAFT_PROPOSAL_CTA: 'LABEL_DRAFT_PROPOSAL_CTA',
  ARCHIVE_TITLE: 'LABEL_ARCHIVE_TITLE',
  ARCHIVE_DESCRIPTION: 'LABEL_ARCHIVE_DESCRIPTION',
  OBLIGATION_PROBLEM_SECTION_TITLE: 'LABEL_OBLIGATION_PROBLEM_SECTION_TITLE',
  OBLIGATION_PROBLEM_TITLE: 'LABEL_OBLIGATION_PROBLEM_TITLE',
  OBLIGATION_CAUSES_TITLE: 'LABEL_OBLIGATION_CAUSES_TITLE',
  OBLIGATION_ANALYSIS_SECTION_TITLE: 'LABEL_OBLIGATION_ANALYSIS_SECTION_TITLE',
  OBLIGATION_DESCRIPTION_ROW_TITLE: 'LABEL_OBLIGATION_DESCRIPTION_ROW_TITLE',
  OBLIGATION_SOLUTION_TITLE: 'LABEL_OBLIGATION_SOLUTION_TITLE',
  OBLIGATION_EXPECTED_RESULTS_TITLE: 'LABEL_OBLIGATION_EXPECTED_RESULTS_TITLE',
  OBLIGATION_DESCRIPTION_TITLE: 'LABEL_OBLIGATION_DESCRIPTION_TITLE',
  OBLIGATION_ANALYSIS_ROW_TITLE: 'LABEL_OBLIGATION_ANALYSIS_ROW_TITLE',
  OBLIGATION_TRANSPARENCY_TITLE: 'LABEL_OBLIGATION_TRANSPARENCY_TITLE',
  OBLIGATION_ACCOUNTABILITY_TITLE: 'LABEL_OBLIGATION_ACCOUNTABILITY_TITLE',
  OBLIGATION_PARTICIPATION_TITLE: 'LABEL_OBLIGATION_PARTICIPATION_TITLE',
  OBLIGATION_PLANNED_ACTIVITIES_TITLE: 'LABEL_OBLIGATION_PLANNED_ACTIVITIES_TITLE',
  DRAFT_PROPOSED_OBLIGATIONS_TITLE: 'LABEL_DRAFT_PROPOSED_OBLIGATIONS_TITLE',
  OBLIGATION_PROBLEM_SECTION_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_PROBLEM_SECTION_TITLE_IMPLEMENTATION',
  OBLIGATION_PROBLEM_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_PROBLEM_TITLE_IMPLEMENTATION',
  OBLIGATION_CAUSES_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_CAUSES_TITLE_IMPLEMENTATION',
  OBLIGATION_ANALYSIS_SECTION_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_ANALYSIS_SECTION_TITLE_IMPLEMENTATION',
  OBLIGATION_DESCRIPTION_ROW_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_DESCRIPTION_ROW_TITLE_IMPLEMENTATION',
  OBLIGATION_SOLUTION_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_SOLUTION_TITLE_IMPLEMENTATION',
  OBLIGATION_EXPECTED_RESULTS_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_EXPECTED_RESULTS_TITLE_IMPLEMENTATION',
  OBLIGATION_DESCRIPTION_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_DESCRIPTION_TITLE_IMPLEMENTATION',
  OBLIGATION_ANALYSIS_ROW_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_ANALYSIS_ROW_TITLE_IMPLEMENTATION',
  OBLIGATION_TRANSPARENCY_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_TRANSPARENCY_TITLE_IMPLEMENTATION',
  OBLIGATION_ACCOUNTABILITY_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_ACCOUNTABILITY_TITLE_IMPLEMENTATION',
  OBLIGATION_PARTICIPATION_TITLE_IMPLEMENTATION: 'LABEL_OBLIGATION_PARTICIPATION_TITLE_IMPLEMENTATION',
  OBLIGATION_IMPLEMENTATION_ACTIVITIES_TITLE: 'LABEL_OBLIGATION_IMPLEMENTATION_ACTIVITIES_TITLE',
  OBLIGATION_IMPLEMENTATION_PROGRESS_SECTION: 'LABEL_OBLIGATION_IMPLEMENTATION_PROGRESS_SECTION',
  OBLIGATION_IMPLEMENTATION_PROGRESS_STATUS: 'LABEL_OBLIGATION_IMPLEMENTATION_PROGRESS_STATUS',
  OBLIGATION_IMPLEMENTATION_PROGRESS_RESULTS: 'LABEL_OBLIGATION_IMPLEMENTATION_PROGRESS_RESULTS',
  DRAFT_PROPOSE_OBLIGATION_BUTTON: 'LABEL_DRAFT_PROPOSE_OBLIGATION_BUTTON',
  DRAFT_PROPOSAL_FORM_TITLE: 'LABEL_DRAFT_PROPOSAL_FORM_TITLE',
  DRAFT_PROPOSAL_PROBLEM_SECTION: 'LABEL_DRAFT_PROPOSAL_PROBLEM_SECTION',
  DRAFT_PROPOSAL_DESCRIPTION_SECTION: 'LABEL_DRAFT_PROPOSAL_DESCRIPTION_SECTION',
  DRAFT_PROPOSAL_ANALYSIS_SECTION: 'LABEL_DRAFT_PROPOSAL_ANALYSIS_SECTION',
};

export const HOME_LABEL_DEFAULTS = {
  [HOME_LABEL_KEYS.GOALS_DESCRIPTION]: 'Циљеви и опис плана',
  [HOME_LABEL_KEYS.OBLIGATIONS_IMPLEMENTATION]: 'Обавезе у спровођењу',
  [HOME_LABEL_KEYS.DOCUMENTS_MATERIALS]: 'Документи и материјали',
  [HOME_LABEL_KEYS.DRAFT_PROPOSAL_CTA]: 'Допринесите изради плана тако што ћете предложити обавезу за овај акциони план.',
  [HOME_LABEL_KEYS.ARCHIVE_TITLE]: 'Истражите архиву акционих планова',
  [HOME_LABEL_KEYS.ARCHIVE_DESCRIPTION]: 'Прегледајте документе, извештаје и материјале из завршених циклуса ОГП Србија.',
  [HOME_LABEL_KEYS.OBLIGATION_PROBLEM_SECTION_TITLE]: 'Дефинисање проблема',
  [HOME_LABEL_KEYS.OBLIGATION_PROBLEM_TITLE]: 'Који проблем се настоји решити обавезом?',
  [HOME_LABEL_KEYS.OBLIGATION_CAUSES_TITLE]: 'Који су узроци проблема?',
  [HOME_LABEL_KEYS.OBLIGATION_ANALYSIS_SECTION_TITLE]: 'Опис и анализа обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_DESCRIPTION_ROW_TITLE]: 'Опис обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_SOLUTION_TITLE]: 'Које решење се предлаже?',
  [HOME_LABEL_KEYS.OBLIGATION_EXPECTED_RESULTS_TITLE]: 'Који резултати се желе постићи спровођењем обавезе?',
  [HOME_LABEL_KEYS.OBLIGATION_DESCRIPTION_TITLE]: 'Шта је до сада урађено у правцу решавања проблема?',
  [HOME_LABEL_KEYS.OBLIGATION_ANALYSIS_ROW_TITLE]: 'Анализа обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_TRANSPARENCY_TITLE]: 'Како ће обавеза промовисати транспарентност?',
  [HOME_LABEL_KEYS.OBLIGATION_ACCOUNTABILITY_TITLE]: 'Како ће обавеза помоћи у подстицању одговорности?',
  [HOME_LABEL_KEYS.OBLIGATION_PARTICIPATION_TITLE]: 'Како ће обавеза унапредити учешће грађана?',
  [HOME_LABEL_KEYS.OBLIGATION_PLANNED_ACTIVITIES_TITLE]: 'Планирање обавезе',
  [HOME_LABEL_KEYS.DRAFT_PROPOSED_OBLIGATIONS_TITLE]: 'Предложене обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_PROBLEM_SECTION_TITLE_IMPLEMENTATION]: 'Проблем који обавеза адресира',
  [HOME_LABEL_KEYS.OBLIGATION_PROBLEM_TITLE_IMPLEMENTATION]: 'Који проблем обавеза решава?',
  [HOME_LABEL_KEYS.OBLIGATION_CAUSES_TITLE_IMPLEMENTATION]: 'Који су кључни узроци проблема?',
  [HOME_LABEL_KEYS.OBLIGATION_ANALYSIS_SECTION_TITLE_IMPLEMENTATION]: 'Решење и праћење ефеката обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_DESCRIPTION_ROW_TITLE_IMPLEMENTATION]: 'Решење и очекивани помаци',
  [HOME_LABEL_KEYS.OBLIGATION_SOLUTION_TITLE_IMPLEMENTATION]: 'Које решење се спроводи?',
  [HOME_LABEL_KEYS.OBLIGATION_EXPECTED_RESULTS_TITLE_IMPLEMENTATION]: 'Који резултати се прате током спровођења?',
  [HOME_LABEL_KEYS.OBLIGATION_DESCRIPTION_TITLE_IMPLEMENTATION]: 'Шта је до сада урађено у спровођењу?',
  [HOME_LABEL_KEYS.OBLIGATION_ANALYSIS_ROW_TITLE_IMPLEMENTATION]: 'Праћење принципа отворене управе',
  [HOME_LABEL_KEYS.OBLIGATION_TRANSPARENCY_TITLE_IMPLEMENTATION]: 'Како обавеза унапређује транспарентност?',
  [HOME_LABEL_KEYS.OBLIGATION_ACCOUNTABILITY_TITLE_IMPLEMENTATION]: 'Како обавеза јача одговорност?',
  [HOME_LABEL_KEYS.OBLIGATION_PARTICIPATION_TITLE_IMPLEMENTATION]: 'Како обавеза унапређује учешће грађана?',
  [HOME_LABEL_KEYS.OBLIGATION_IMPLEMENTATION_ACTIVITIES_TITLE]: 'Спровођење активности',
  [HOME_LABEL_KEYS.OBLIGATION_IMPLEMENTATION_PROGRESS_SECTION]: 'Информације о досадашњем спровођењу обавезе',
  [HOME_LABEL_KEYS.OBLIGATION_IMPLEMENTATION_PROGRESS_STATUS]: 'Статус спровођења (укупни статус обавезе)',
  [HOME_LABEL_KEYS.OBLIGATION_IMPLEMENTATION_PROGRESS_RESULTS]: 'Опис досадашњих резултата',
  [HOME_LABEL_KEYS.DRAFT_PROPOSE_OBLIGATION_BUTTON]: 'Предложите обавезу',
  [HOME_LABEL_KEYS.DRAFT_PROPOSAL_FORM_TITLE]: 'ОБРАЗАЦ за достављање предлога обавезе',
  [HOME_LABEL_KEYS.DRAFT_PROPOSAL_PROBLEM_SECTION]: 'Дефинисање проблема',
  [HOME_LABEL_KEYS.DRAFT_PROPOSAL_DESCRIPTION_SECTION]: 'Опис обавезе',
  [HOME_LABEL_KEYS.DRAFT_PROPOSAL_ANALYSIS_SECTION]: 'Анализа обавезе',
};

export const DEFAULT_POU_CONTENT = `
  <p>
    <strong>Партнерство за отворену управу - ПОУ</strong> ( <a href="https://www.opengovpartnership.org/" target="_blank" rel="noopener noreferrer" class="pou-link">https://www.opengovpartnership.org/</a> ) је међународна иницијатива чија је сврха унапређење основних вредности и принципа отворене управе (попут учешћа јавности у доношењу одлука, транспарентности и одговорности органа јавне власти, уз употребу иновација и технологија), кроз блиску сарадњу органа управе са грађанима, цивилним друштвом, приватним сектором и осталом заинтересованом јавношћу.

    Формално покренута 2011. године од стране осам држава, ова иницијатива данас окупља <strong>75 држава и 106 локалних заједница</strong> широм света. Израда и спровођење двогодишњих акционих планова у циљу унапређења стања у областима обухваћеним вредностима ПОУ кључна је обавеза која произлази из учешћа у овој иницијативи.

    Република Србија је приступила ПОУ 2012. године и од тада донела и имплементирала <strong>четири акциона плана</strong>.
  </p>
  <p>
    <strong>Национална контакт особа за спровођење ПОУ:</strong> Драгана Брајовић, Министарство државне управе и локалне самоуправе, <a href="mailto:dragana.brajovic@mduls.gov.rs" class="pou-link">dragana.brajovic@mduls.gov.rs</a>
  </p>
`;

export const DEFAULT_AP_INFO_CONTENT = `
  <p>
    У наставку странице приказане су информације о <strong>акционом плану у спровођењу</strong>
    и, када постоји, о <strong>акционом плану у припреми</strong>.
  </p>
  <p>
    Кроз ове секције можете да прегледате обавезе, филтрирате и претражујете предлоге,
    као и да приступите пратећим документима и материјалима. Архива омогућава увид
    у завршене акционе планове и њихово спровођење.
  </p>
  <p>
    Ако је акциони план у припреми доступан, са почетне странице можете да
    <a href="#draft-obligation-proposal-cta">пошаљете предлог обавезе</a>.
    За слање предлога потребно је да будете пријављени.
  </p>
`;

export const DEFAULT_AP_EMPTY_STATE_CONTENT = `
  <p>
    Тренутно <strong>нема акционог плана у спровођењу нити акционог плана у припреми</strong>.
  </p>
  <p>
    Када нови акциони план буде покренут или усвојен, овде ће бити доступне информације
    о његовим обавезама, документима и извештајима.
  </p>
`;

export const PROPOSALS_STATUS_OPTIONS = [
  { value: 'CREATED', label: 'Предложена', color: '#d97706', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'UNDER_REVIEW', label: 'У прегледу', color: '#d97706', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'ACCEPTED', label: 'Прихваћена', color: '#047857', bgColor: '#d1fae5', borderColor: '#10b981', inactiveBgColor: '#ecfdf5' },
  { value: 'PARTIALLY_ACCEPTED', label: 'Делимично прихваћена', color: '#92400e', bgColor: '#fef3c7', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'REJECTED', label: 'Ниеј прихваћено', color: '#991b1b', bgColor: '#fee2e2', borderColor: '#fca5a5', inactiveBgColor: '#fef2f2' },
  { value: 'REJECTED_AFTER_REVIEW', label: 'Није прихваћена након прегледа', color: '#991b1b', bgColor: '#fee2e2', borderColor: '#fca5a5', inactiveBgColor: '#fef2f2' },
];

export const DOCUMENTS_STATUS_OPTIONS = [
  { value: 'published', label: 'Објављено', color: '#047857', bgColor: '#d1fae5', borderColor: '#10b981', inactiveBgColor: '#ecfdf5' },
  { value: 'draft', label: 'Нацрт', color: '#78350f', bgColor: '#fef9c3', borderColor: '#f59e0b', inactiveBgColor: '#fffbeb' },
  { value: 'archived', label: 'Архивирано', color: '#1f2937', bgColor: '#f3f4f6', borderColor: '#6b7280', inactiveBgColor: '#f9fafb' },
];

export const OBLIGATIONS_PAGE_SIZE = 3;
export const OBLIGATIONS_PAGE_SIZE_OPTIONS = [3, 5, 10, 20];

